import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import Loading from './Loading'; // Importar o componente de carregamento
import log from './services/logService';

const ACCESS_TOKEN_COOKIE = process.env.REACT_APP_ACCESS_TOKEN_COOKIE;
const REFRESH_TOKEN_COOKIE = process.env.REACT_APP_REFRESH_TOKEN_COOKIE;

const GoogleCallback = () => {
  const [code, setCode] = useState(null);
  const [loading, setLoading] = useState(true); // Estado para controlar o carregamento
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const codeParam = urlParams.get('code');
    if (codeParam) {
      setCode(codeParam);
    } else {
      setLoading(false); // Esconder o carregamento se não houver código
    }
  }, []);

  useEffect(() => {
    if (code) {
      log('Código de autorização recebido:', code);
      log('Endpoint do Google Login:', process.env.REACT_APP_REDIRECT_LAMBDA_GOOGLE_URI);

      fetch(process.env.REACT_APP_REDIRECT_LAMBDA_GOOGLE_URI, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
body: JSON.stringify({ code }),
      })
      .then(response => {
        log('Resposta completa servidor:', response);
        log('Response status:', response.status);
        log('Response headers:', [...response.headers.entries()]);
        if (!response.ok) {
          throw new Error(`HTTP Error: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        log('Response data:', data);

        if (data.success) {
          log('Login bem-sucedido. Dados do usuário:', data.user);
          log('Tokens recebidos:', {
            accessToken: data.accessToken,
            refreshToken: data.refreshToken,
          });

          // Definir expiração dos tokens
          const accessTokenExpiration = new Date(new Date().getTime() + process.env.REACT_APP_JWT_EXPIRATION * 60 * 1000); // 2 minutos
          const refreshTokenExpiration = new Date(new Date().getTime() + process.env.REACT_APP_JWT_REFRESH_EXPIRATION * 24 * 60 * 60 * 1000); // 7 dias

          log('Expiração do Access Token:', accessTokenExpiration);
          log('Expiração do Refresh Token:', refreshTokenExpiration);

          Cookies.set(ACCESS_TOKEN_COOKIE, data.accessToken, { expires: accessTokenExpiration, secure: true, sameSite: 'Strict' });
          Cookies.set(REFRESH_TOKEN_COOKIE, data.refreshToken, { expires: refreshTokenExpiration, secure: true, sameSite: 'Strict' });

          log('Cookies definidos com sucesso.');
          navigate("/dashboard", { state: { user: data.user } });
        } else {
          log('Falha no login. Mensagem do servidor:', data.message);
          alert(data.message);
        }
      })
      .catch(error => {
        log('Erro ao chamar o endpoint do Google Login:', error);
      })
      .finally(() => {
        log('Finalizando o processo de login.');
        setLoading(false); // Esconder o carregamento após a conclusão
      });
    } else {
      log('Nenhum código de autorização encontrado.');
    }
  }, [code, navigate]);

  return (
    <div>
      {loading && <Loading />} {/* Renderizar o componente de carregamento */}
      <h1>Google Callback</h1>
      {code ? <p>Processando login...</p> : <p>Obtendo código de autorização...</p>}
    </div>
  );
};

export default GoogleCallback;